import { render, staticRenderFns } from "./AmendmentForm.vue?vue&type=template&id=4e1b1dc7&"
import script from "./AmendmentForm.vue?vue&type=script&lang=js&"
export * from "./AmendmentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports